export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Google Veo 3.1 视频生成器 - 免费体验最新AI视频创作工具',
        pageDescription:
            '体验Google Veo 3.1 视频生成器，支持连帧成片、素材生视频、原生音频生成等核心功能。在WeryAI平台免费试用，创造专业级AI视频内容。',
        pageKeywords:
            'Veo 3.1, Google AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3.1 视频生成器',
        generatorDescription:
            'WeryAI 现已深度集成Veo 3.1模型，能够生成高质量、逼真自然的音频视频。它是 Veo 3 的升级版本，在质量和功能上都有显著提升。快来 WeryAI 视频生成器免费体验 Veo 3.1 ！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3.1 核心功能特性',
        coreFeaturesSubtitle:
            '深入了解 Google Veo 3.1 视频生成器的核心功能，体验下一代AI视频创作技术',

        // 连帧成片功能
        frameToVideoTitle: '连帧成片（首尾帧控制）',
        frameToVideoDescription:
            'Veo 3.1 支持通过首尾帧控制视频生成，让您精确掌控视频的起始和结束画面，创造更具连贯性的视觉叙事。',
        frameToFrameTitle: '帧间控制',
        frameToFrameDescription:
            '通过指定首尾帧来控制视频生成，创建流畅的过渡和连贯的视觉叙事。',

        // 素材生视频功能
        materialToVideoTitle: '素材生视频',
        materialToVideoDescription:
            '基于现有素材和参考材料创建高质量视频，实现素材的智能化二次创作和视觉升级。',

        // 原生音频生成功能
        nativeAudioTitle: '原生音频生成',
        nativeAudioDescription:
            'Veo 3.1 创建音频并将其集成到生成的视频中，实现完美的视听同步体验，让您的视频更具吸引力和真实感。',

        // 一致角色功能
        consistentCharacterTitle: '一致的角色表现',
        consistentCharacterDescription:
            '确保角色在不同场景和镜头中保持高度一致的外观和特征，创造连贯的视觉体验。',

        // 高级提示理解功能
        advancedPromptTitle: '高级提示词理解',
        advancedPromptDescription:
            '高精度地解读复杂提示词，准确理解您的创意意图，将文字描述转化为生动的视觉画面。',

        // 场景扩展功能
        sceneExpansionTitle: '强大的场景扩展',
        sceneExpansionDescription:
            '智能扩展视频场景，生成更丰富的视觉内容，让您的创意突破时间和空间的限制。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Veo 3.1 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeVideosTitle: 'Google Veo 3.1 视频模型相关 YouTube 视频',
        youtubeVideoTitle: 'Google Veo 3.1 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3.1 AI 视频模型的 X 推文',

        // 探索其他模型部分
        exploreOtherModelsTitle: '探索其他 Veo 模型',
        veo2Title: 'Google Veo 2 AI视频生成器',
        veo3Title: 'Google Veo 3 AI视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3.1，将您的创意转化为精彩视频',
        ctaDescription:
            '体验 Veo 3.1 的强大功能，将您的创意想法转化为专业视频内容',
        ctaButton: '开始创作',
        ctaNote: '无需信用卡 · 新用户免费体验',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Advanced AI Video Generation Model | WeryAI',
        pageDescription:
            'Google Veo 3.1 generates high-quality, realistic videos with frame control, material-to-video, native audio, scene expansion, and precise prompt understanding. Try it free on WeryAI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI video generator, advanced video model, text to video, AI video creation, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI Video Generator',
        generatorDescription:
            'WeryAI now deeply integrates the Veo 3.1 model, realistic audio-visual content. It\'s an upgraded version of Veo 3 with significant improvements in quality and features. Try Veo 3.1 for free on WeryAI video generator!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 Core Features',
        coreFeaturesSubtitle:
            'Explore the core capabilities of Google Veo 3.1 AI video generator and experience next-generation AI video creation',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (First & Last Frame Control)',
        frameToVideoDescription:
            'Veo 3.1 supports video generation through first and last frame control, allowing you to precisely control the start and end frames of your video for more coherent visual storytelling.',
        frameToFrameTitle: 'Frame-to-Frame Control',
        frameToFrameDescription:
            'Control video generation by specifying the first and last frame, creating smooth transitions and coherent visual narratives.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Create high-quality videos based on existing materials and references, enabling intelligent recreation and visual enhancement of your content.',

        // Native audio generation feature
        nativeAudioTitle: 'Native Audio Generation',
        nativeAudioDescription:
            'Veo 3.1 creates audio and integrates it into generated videos, achieving perfect audio-visual synchronization for more engaging and realistic content.',

        // Consistent character feature
        consistentCharacterTitle: 'Consistent Character Performance',
        consistentCharacterDescription:
            'Ensure characters maintain highly consistent appearance and characteristics across different scenes and shots, creating a coherent visual experience.',

        // Advanced prompt feature
        advancedPromptTitle: 'Advanced Prompt Understanding',
        advancedPromptDescription:
            'Precisely interpret complex prompts, accurately understand your creative intent, and transform text descriptions into vivid visual scenes.',

        // Scene expansion feature
        sceneExpansionTitle: 'Powerful Scene Expansion',
        sceneExpansionDescription:
            'Intelligently expand video scenes to generate richer visual content, letting your creativity break through time and space limitations.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start Creating in Three Simple Steps',
        step1Title: 'Select Model',
        step1Description: 'Choose Veo 3.1 model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter text prompt or upload reference image',
        step3Title: 'Generate Video',
        step3Description: 'Click generate button, wait and download your video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube Videos about Google Veo 3.1 AI Video Model',
        youtubeVideoTitle: 'YouTube Videos about Google Veo 3.1 AI Video Model',

        // X Posts section
        xPostsTitle: 'X Posts about Veo 3.1 AI Video Model',

        // Explore other models section
        exploreOtherModelsTitle: 'Explore Other Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Try Veo 3.1 now and transform your ideas into stunning videos',
        ctaDescription:
            'Experience the power of Veo 3.1 and turn your creative ideas into professional video content.',
        ctaButton: 'Start Creating',
        ctaNote: 'No credit card required · Free trial for new users',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'Google Veo 3.1 AI動画ジェネレーター - 無料で最新のAI動画作成ツールを体験',
        pageDescription:
            'Google Veo 3.1 AI動画ジェネレーターを体験。フレーム連結、素材から動画、ネイティブオーディオ生成などのコア機能をサポート。WeryAIプラットフォームで無料でお試しいただき、プロフェッショナルなAI動画コンテンツを作成できます。',
        pageKeywords:
            'Veo 3.1, Google AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, WeryAI, 動画制作',

        // ジェネレーターセクション
        generatorTitle: 'Google Veo 3.1 AI動画ジェネレーター',
        generatorDescription:
            'WeryAI はVeo 3.1モデルを深く統合し、Veo 3のアップグレード版で、品質と機能が大幅に向上しています。WeryAI動画ジェネレーターでVeo 3.1を無料でお試しください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能セクション
        coreFeaturesTitle: 'Veo 3.1のコア機能',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI動画ジェネレーターのコア機能を探索し、次世代のAI動画作成を体験',

        // フレーム連結機能
        frameToVideoTitle: 'フレーム連結（最初と最後のフレーム制御）',
        frameToVideoDescription:
            'Veo 3.1は最初と最後のフレーム制御による動画生成をサポートし、動画の開始と終了フレームを正確に制御して、より一貫性のあるビジュアルストーリーテリングを実現します。',
        frameToFrameTitle: 'フレーム間制御',
        frameToFrameDescription:
            '最初と最後のフレームを指定して動画生成を制御し、滑らかなトランジションと一貫性のあるビジュアルナラティブを作成します。',

        // 素材から動画機能
        materialToVideoTitle: '素材から動画',
        materialToVideoDescription:
            '既存の素材や参考資料に基づいて高品質な動画を作成し、コンテンツのインテリジェントな再創作とビジュアルアップグレードを実現します。',

        // ネイティブオーディオ生成機能
        nativeAudioTitle: 'ネイティブオーディオ生成',
        nativeAudioDescription:
            'Veo 3.1はオーディオを作成し、生成された動画に統合することで、完璧な音声と映像の同期を実現し、より魅力的でリアルなコンテンツを提供します。',

        // 一貫したキャラクター機能
        consistentCharacterTitle: '一貫したキャラクターパフォーマンス',
        consistentCharacterDescription:
            'キャラクターが異なるシーンやショットで高度に一貫した外観と特徴を維持し、一貫性のある視覚体験を創出します。',

        // 高度なプロンプト機能
        advancedPromptTitle: '高度なプロンプト理解',
        advancedPromptDescription:
            '複雑なプロンプトを正確に解釈し、クリエイティブな意図を正確に理解して、テキストの説明を生き生きとした視覚シーンに変換します。',

        // シーン拡張機能
        sceneExpansionTitle: '強力なシーン拡張',
        sceneExpansionDescription:
            '動画シーンをインテリジェントに拡張してより豊かなビジュアルコンテンツを生成し、創造性が時間と空間の制限を突破できるようにします。',

        // 使い方セクション
        howToUseTitle: '使い方',
        howToUseSubtitle: '3つの簡単なステップで作成開始',
        step1Title: 'モデル選択',
        step1Description: 'AI動画ツールでVeo 3.1モデルを選択',
        step2Title: 'コンテンツ入力',
        step2Description:
            'テキストプロンプトを入力または参考画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックして、動画を待ってダウンロード',

        // YouTube動画セクション
        youtubeVideosTitle: 'Google Veo 3.1 AI動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'Google Veo 3.1 AI動画モデルに関するYouTube動画',

        // X投稿セクション
        xPostsTitle: 'Veo 3.1 AI動画モデルに関するX投稿',

        // 他のモデルを探索セクション
        exploreOtherModelsTitle: '他のVeoモデルを探索',
        veo2Title: 'Google Veo 2 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        veo3FastTitle: 'Google Veo 3 Fast AI動画ジェネレーター',

        // FAQセクション
        faqTitle: 'よくある質問',

        // CTAセクション
        ctaTitle: '作成を開始する準備はできましたか？',
        ctaSubtitle: '今すぐVeo 3.1を試して、アイデアを素晴らしい動画に変換',
        ctaDescription:
            'Veo 3.1の強力な機能を体験し、あなたの創造的なアイデアをプロフェッショナルな動画コンテンツに変換',
        ctaButton: 'WeryAIでVeo 3.1を試す',
        ctaNote: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목 및 설명
        pageTitle:
            'Google Veo 3.1 AI 비디오 생성기 - 무료 최신 AI 비디오 제작 도구 체험',
        pageDescription:
            'Google Veo 3.1 AI 비디오 생성기를 체험하세요. 프레임 연결, 소재에서 비디오, 네이티브 오디오 생성 등의 핵심 기능을 지원합니다. WeryAI 플랫폼에서 무료로 체험하고 전문 AI 비디오 콘텐츠를 만들어보세요.',
        pageKeywords:
            'Veo 3.1, Google AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 비디오 제작',

        // 생성기 섹션
        generatorTitle: 'Google Veo 3.1 AI 비디오 생성기',
        generatorDescription:
            'WeryAI는 이제 Veo 3.1 모델을 심층 통합하여, Veo 3의 업그레이드 버전으로 품질과 기능이 크게 향상되었습니다. WeryAI 비디오 생성기에서 Veo 3.1을 무료로 체험하세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 섹션
        coreFeaturesTitle: 'Veo 3.1 핵심 기능',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI 비디오 생성기의 핵심 기능을 탐색하고 차세대 AI 비디오 제작을 경험하세요',

        // 프레임 연결 기능
        frameToVideoTitle: '프레임 연결 (시작 및 끝 프레임 제어)',
        frameToVideoDescription:
            'Veo 3.1은 시작 및 끝 프레임 제어를 통한 비디오 생성을 지원하여 비디오의 시작과 끝 프레임을 정확하게 제어하고 더 일관된 비주얼 스토리텔링을 구현합니다.',
        frameToFrameTitle: '프레임 간 제어',
        frameToFrameDescription:
            '시작 및 끝 프레임을 지정하여 비디오 생성을 제어하고 부드러운 전환과 일관된 비주얼 내러티브를 생성합니다.',

        // 소재에서 비디오 기능
        materialToVideoTitle: '소재에서 비디오',
        materialToVideoDescription:
            '기존 소재 및 참고 자료를 기반으로 고품질 비디오를 생성하여 콘텐츠의 지능적인 재창작과 비주얼 업그레이드를 실현합니다.',

        // 네이티브 오디오 생성 기능
        nativeAudioTitle: '네이티브 오디오 생성',
        nativeAudioDescription:
            'Veo 3.1은 오디오를 생성하고 생성된 비디오에 통합하여 완벽한 오디오-비주얼 동기화를 달성하고 더 매력적이고 사실적인 콘텐츠를 제공합니다.',

        // 일관된 캐릭터 기능
        consistentCharacterTitle: '일관된 캐릭터 표현',
        consistentCharacterDescription:
            '캐릭터가 다른 장면과 샷에서 높은 일관성을 유지하여 일관된 비주얼 경험을 창출합니다.',

        // 고급 프롬프트 기능
        advancedPromptTitle: '고급 프롬프트 이해',
        advancedPromptDescription:
            '복잡한 프롬프트를 정확하게 해석하고 창의적인 의도를 정확하게 이해하여 텍스트 설명을 생생한 비주얼 장면으로 변환합니다.',

        // 장면 확장 기능
        sceneExpansionTitle: '강력한 장면 확장',
        sceneExpansionDescription:
            '비디오 장면을 지능적으로 확장하여 더 풍부한 비주얼 콘텐츠를 생성하고 창의성이 시간과 공간의 제한을 돌파하도록 합니다.',

        // 사용 방법 섹션
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '3단계로 시작하는 제작',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Veo 3.1 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '텍스트 프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭 후 대기 및 비디오 다운로드',

        // YouTube 비디오 섹션
        youtubeVideosTitle: 'Google Veo 3.1 AI 비디오 모델 관련 YouTube 비디오',
        youtubeVideoTitle: 'Google Veo 3.1 AI 비디오 모델 관련 YouTube 비디오',

        // X 게시물 섹션
        xPostsTitle: 'Veo 3.1 AI 비디오 모델 관련 X 게시물',

        // 다른 모델 탐색 섹션
        exploreOtherModelsTitle: '다른 Veo 모델 탐색',
        veo2Title: 'Google Veo 2 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',

        // FAQ 섹션
        faqTitle: '자주 묻는 질문',

        // CTA 섹션
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle:
            '지금 Veo 3.1을 체험하고 아이디어를 멋진 비디오로 변환하세요',
        ctaDescription:
            'Veo 3.1의 강력한 기능을 경험하고 창의적인 아이디어를 전문적인 비디오 콘텐츠로 변환하세요',
        ctaButton: 'WeryAI에서 Veo 3.1 체험하기',
        ctaNote: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadError: '비디오 로드 실패',
        videoReload: '다시 로드',
    },
    tw: {
        // 頁面標題和描述
        pageTitle: 'Google Veo 3.1 影片產生器 - 免費體驗最新 AI 影片創作工具',
        pageDescription:
            '體驗 Google Veo 3.1 影片產生器，支援連幀成片、素材生影片、原生音訊生成等核心功能。在 WeryAI 平台免費試用，創造專業級 AI 影片內容。',
        pageKeywords:
            'Veo 3.1, Google AI影片產生器, AI影片創作, 人工智慧影片, 影片生成工具, 免費AI影片, WeryAI, 影片製作',

        // 生成器部分
        generatorTitle: 'Google Veo 3.1 影片產生器',
        generatorDescription:
            'WeryAI 現已深度整合Veo 3.1模型，能夠生成高品質、逼真自然的音訊影片。它是 Veo 3 的升級版本，在品質和功能上都有顯著提升。快來 WeryAI 影片產生器免費體驗 Veo 3.1！',

        // 標籤頁
        tabImageToVideo: '圖生影片',
        tabTextToVideo: '文生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3.1 核心功能特性',
        coreFeaturesSubtitle:
            '深入了解 Google Veo 3.1 影片產生器的核心功能，體驗下一代 AI 影片創作技術',

        // 連幀成片功能
        frameToVideoTitle: '連幀成片（首尾幀控制）',
        frameToVideoDescription:
            'Veo 3.1 支援透過首尾幀控制影片生成，讓您精確掌控影片的起始和結束畫面，創造更具連貫性的視覺敘事。',
        frameToFrameTitle: '幀間控制',
        frameToFrameDescription:
            '透過指定首尾幀來控制影片生成，建立流暢的過渡和連貫的視覺敘事。',

        // 素材生影片功能
        materialToVideoTitle: '素材生影片',
        materialToVideoDescription:
            '基於現有素材和參考材料建立高品質影片，實現素材的智慧化二次創作和視覺升級。',

        // 原生音訊生成功能
        nativeAudioTitle: '原生音訊生成',
        nativeAudioDescription:
            'Veo 3.1 建立音訊並將其整合到生成的影片中，實現完美的視聽同步體驗，讓您的影片更具吸引力和真實感。',

        // 一致角色功能
        consistentCharacterTitle: '一致的角色表現',
        consistentCharacterDescription:
            '確保角色在不同場景和鏡頭中保持高度一致的外觀和特徵，創造連貫的視覺體驗。',

        // 高級提示理解功能
        advancedPromptTitle: '高級提示詞理解',
        advancedPromptDescription:
            '高精度地解讀複雜提示詞，準確理解您的創意意圖，將文字描述轉化為生動的視覺畫面。',

        // 場景擴展功能
        sceneExpansionTitle: '強大的場景擴展',
        sceneExpansionDescription:
            '智慧擴充影片場景，生成更豐富的視覺內容，讓您的創意突破時間和空間的限制。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '簡單三步，開始創作',
        step1Title: '選擇模型',
        step1Description: '在 AI 影片工具中選擇 Veo 3.1 模型',
        step2Title: '輸入內容',
        step2Description: '輸入提示詞或上傳參考圖像',
        step3Title: '生成影片',
        step3Description: '點擊生成按鈕，等待並下載您的影片',

        // YouTube 影片部分
        youtubeVideosTitle: 'Google Veo 3.1 影片模型相關 YouTube 影片',
        youtubeVideoTitle: 'Google Veo 3.1 影片模型相關 YouTube 影片',

        // X Posts 部分
        xPostsTitle: '關於 Veo 3.1 AI 影片模型的 X 推文',

        // 探索其他模型部分
        exploreOtherModelsTitle: '探索其他 Veo 模型',
        veo2Title: 'Google Veo 2 AI影片產生器',
        veo3Title: 'Google Veo 3 AI影片產生器',
        veo3FastTitle: 'Google Veo 3 Fast AI影片產生器',

        // FAQ 部分
        faqTitle: '常見問題解答',

        // CTA 部分
        ctaTitle: '準備開始創作了嗎？',
        ctaSubtitle: '立即體驗 Veo 3.1，將您的創意轉化為精彩影片',
        ctaDescription:
            '體驗 Veo 3.1 的強大功能，將您的創意想法轉化為專業影片內容',
        ctaButton: '開始創作',
        ctaNote: '無需信用卡 · 新使用者免費體驗',

        // 影片播放相關
        videoNotSupported: '您的瀏覽器不支援影片播放',
        videoUnsupported: '您的瀏覽器不支援影片播放',
        videoLoadError: '影片載入失敗',
        videoReload: '重新載入',
    },
    pl: {
        // Tytuł i opis strony
        pageTitle: 'Generator wideo Google Veo 3.1 - Wypróbuj za darmo najnowocześniejsze narzędzie do tworzenia wideo AI',
        pageDescription:
            'Poznaj generator wideo Google Veo 3.1, obsługujący kluczowe funkcje, takie jak łączenie klatek, tworzenie wideo z materiałów oraz natywne generowanie dźwięku. Wypróbuj za darmo na platformie WeryAI i twórz profesjonalne treści wideo AI.',
        pageKeywords:
            'Veo 3.1, generator wideo Google AI, tworzenie wideo AI, wideo ze sztuczną inteligencją, narzędzie do generowania wideo, darmowe wideo AI, WeryAI, produkcja wideo',

        // Sekcja generatora
        generatorTitle: 'Generator wideo Google Veo 3.1 AI',
        generatorDescription:
            'WeryAI jest teraz głęboko zintegrowane z modelem Veo 3.1, który generuje wysokiej jakości, realistyczne treści audiowizualne. Jest to ulepszona wersja Veo 3 ze znaczącymi usprawnieniami w jakości i funkcjach. Wypróbuj Veo 3.1 za darmo w generatorze wideo WeryAI!',

        // Karty
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',

        // Sekcja kluczowych funkcji
        coreFeaturesTitle: 'Kluczowe funkcje Veo 3.1',
        coreFeaturesSubtitle:
            'Poznaj podstawowe możliwości generatora wideo Google Veo 3.1 AI i doświadcz tworzenia wideo AI nowej generacji',

        // Funkcja klatka do wideo
        frameToVideoTitle: 'Klatka do wideo (kontrola pierwszej i ostatniej klatki)',
        frameToVideoDescription:
            'Veo 3.1 obsługuje generowanie wideo poprzez kontrolę pierwszej i ostatniej klatki, co pozwala na precyzyjne sterowanie początkowym i końcowym obrazem wideo dla bardziej spójnej narracji wizualnej.',
        frameToFrameTitle: 'Kontrola międzyklatkowa',
        frameToFrameDescription:
            'Kontroluj generowanie wideo, określając pierwszą i ostatnią klatkę, tworząc płynne przejścia i spójne narracje wizualne.',

        // Funkcja materiał do wideo
        materialToVideoTitle: 'Materiał na wideo',
        materialToVideoDescription:
            'Twórz wysokiej jakości filmy wideo na podstawie istniejących materiałów i referencji, umożliwiając inteligentne ponowne tworzenie i wizualne ulepszanie Twoich treści.',

        // Funkcja natywnego generowania dźwięku
        nativeAudioTitle: 'Natywne generowanie dźwięku',
        nativeAudioDescription:
            'Veo 3.1 tworzy dźwięk i integruje go z wygenerowanymi filmami, osiągając idealną synchronizację audio-wizualną dla bardziej angażujących i realistycznych treści.',

        // Funkcja spójności postaci
        consistentCharacterTitle: 'Spójne zachowanie postaci',
        consistentCharacterDescription:
            'Zapewnij postaciom wysoce spójny wygląd i cechy w różnych scenach i ujęciach, tworząc jednolite wrażenia wizualne.',

        // Zaawansowana funkcja rozumienia promptów
        advancedPromptTitle: 'Zaawansowane rozumienie promptów',
        advancedPromptDescription:
            'Precyzyjnie interpretuj złożone prompty, dokładnie zrozum swoje intencje twórcze i przekształcaj opisy tekstowe w żywe sceny wizualne.',

        // Funkcja rozszerzania sceny
        sceneExpansionTitle: 'Potężne rozszerzanie sceny',
        sceneExpansionDescription:
            'Inteligentnie rozszerzaj sceny wideo, aby generować bogatszą zawartość wizualną, pozwalając swojej kreatywności przełamywać ograniczenia czasu i przestrzeni.',

        // Sekcja jak używać
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Zacznij tworzyć w trzech prostych krokach',
        step1Title: 'Wybierz model',
        step1Description: 'Wybierz model Veo 3.1 w narzędziach wideo AI',
        step2Title: 'Wprowadź treść',
        step2Description: 'Wpisz prompt tekstowy lub prześlij obraz referencyjny',
        step3Title: 'Generuj wideo',
        step3Description: 'Kliknij przycisk generowania, zaczekaj i pobierz swoje wideo',

        // Sekcja filmów YouTube
        youtubeVideosTitle: 'Filmy YouTube o modelu wideo Google Veo 3.1 AI',
        youtubeVideoTitle: 'Filmy YouTube o modelu wideo Google Veo 3.1 AI',

        // Sekcja postów X
        xPostsTitle: 'Posty X o modelu wideo Google Veo 3.1 AI',

        // Sekcja odkrywania innych modeli
        exploreOtherModelsTitle: 'Poznaj inne modele Veo',
        veo2Title: 'Generator wideo Google Veo 2 AI',
        veo3Title: 'Generator wideo Google Veo 3 AI',
        veo3FastTitle: 'Generator wideo Google Veo 3 Fast AI',

        // Sekcja FAQ
        faqTitle: 'Często zadawane pytania',

        // Sekcja CTA
        ctaTitle: 'Gotowy, by zacząć tworzyć?',
        ctaSubtitle: 'Wypróbuj Veo 3.1 już teraz i przekształć swoje pomysły w niesamowite filmy',
        ctaDescription:
            'Poznaj moc Veo 3.1 i zamień swoje kreatywne pomysły w profesjonalne treści wideo.',
        ctaButton: 'Zacznij tworzyć',
        ctaNote: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',

        // Powiązane z odtwarzaniem wideo
        videoNotSupported: 'Twoja przeglądarkarka nie obsługuje odtwarzania wideo',
        videoUnsupported: 'Twoja przeglądarkarka nie obsługuje odtwarzania wideo',
        videoLoadError: 'Nie udało się załadować wideo',
        videoReload: 'Załaduj ponownie',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de Video IA Google Veo 3.1 - Herramienta Avanzada de Creación de Video IA Gratis',
        pageDescription:
            'Experimenta el generador de video IA Google Veo 3.1 con fotograma a video, material a video, generación de audio nativo y más. Pruébalo gratis en la plataforma WeryAI para crear videos IA profesionales.',
        pageKeywords:
            'Veo 3.1, generador de video IA de Google, creación de video IA, video de inteligencia artificial, herramienta de generación de video, video IA gratis, WeryAI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de Video IA Google Veo 3.1',
        generatorDescription:
            'WeryAI ahora integra profundamente el modelo Veo 3.1, Es una versión mejorada de Veo 3 con mejoras significativas en calidad y funciones. ¡Prueba Veo 3.1 gratis en el generador de video WeryAI!',

        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Veo 3.1',
        coreFeaturesSubtitle:
            'Explora las capacidades principales del generador de video IA Google Veo 3.1 y experimenta la creación de video IA de próxima generación',

        // Función de fotograma a video
        frameToVideoTitle:
            'Fotograma a Video (Control de Primer y Último Fotograma)',
        frameToVideoDescription:
            'Veo 3.1 soporta generación de video mediante control de primer y último fotograma, permitiéndote controlar con precisión los fotogramas inicial y final de tu video para una narración visual más coherente.',
        frameToFrameTitle: 'Control Fotograma a Fotograma',
        frameToFrameDescription:
            'Controla la generación de video especificando el primer y último fotograma, creando transiciones suaves y narrativas visuales coherentes.',

        // Función de material a video
        materialToVideoTitle: 'Material a Video',
        materialToVideoDescription:
            'Crea videos de alta calidad basados en materiales y referencias existentes, permitiendo recreación inteligente y mejora visual de tu contenido.',

        // Función de generación de audio nativo
        nativeAudioTitle: 'Generación de Audio Nativo',
        nativeAudioDescription:
            'Veo 3.1 crea audio y lo integra en videos generados, logrando sincronización audiovisual perfecta para contenido más atractivo y realista.',

        // Función de personaje consistente
        consistentCharacterTitle: 'Rendimiento de Personaje Consistente',
        consistentCharacterDescription:
            'Asegura que los personajes mantengan apariencia y características altamente consistentes en diferentes escenas y tomas, creando una experiencia visual coherente.',

        // Función de prompt avanzado
        advancedPromptTitle: 'Comprensión Avanzada de Prompts',
        advancedPromptDescription:
            'Interpreta con precisión prompts complejos, comprende con exactitud tu intención creativa y transforma descripciones de texto en escenas visuales vívidas.',

        // Función de expansión de escenas
        sceneExpansionTitle: 'Expansión de Escenas Poderosa',
        sceneExpansionDescription:
            'Expande inteligentemente las escenas de video para generar contenido visual más rico, permitiendo que tu creatividad rompa las limitaciones de tiempo y espacio.',

        // Sección cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Comienza a Crear en Tres Simples Pasos',
        step1Title: 'Seleccionar Modelo',
        step1Description:
            'Elige el modelo Veo 3.1 en las herramientas de video IA',
        step2Title: 'Introducir Contenido',
        step2Description:
            'Introduce prompt de texto o sube imagen de referencia',
        step3Title: 'Generar Video',
        step3Description:
            'Haz clic en el botón generar, espera y descarga tu video',

        // Sección de videos de YouTube
        youtubeVideosTitle:
            'Videos de YouTube sobre el Modelo de Video IA Google Veo 3.1',
        youtubeVideoTitle:
            'Videos de YouTube sobre el Modelo de Video IA Google Veo 3.1',

        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones de X sobre el Modelo de Video IA Veo 3.1',

        // Sección explorar otros modelos
        exploreOtherModelsTitle: 'Explorar Otros Modelos Veo',
        veo2Title: 'Generador de Video IA Google Veo 2',
        veo3Title: 'Generador de Video IA Google Veo 3',
        veo3FastTitle: 'Generador de Video IA Google Veo 3 Fast',

        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',

        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaSubtitle:
            'Prueba Veo 3.1 ahora y transforma tus ideas en videos impresionantes',
        ctaDescription:
            'Experimenta el poder de Veo 3.1 y convierte tus ideas creativas en contenido de video profesional.',
        ctaButton: 'Prueba Veo 3.1 en WeryAI',
        ctaNote: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no soporta reproducción de video',
        videoUnsupported: 'Su navegador no soporta reproducción de video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur Vidéo IA Google Veo 3.1 - Outil Avancé de Création Vidéo IA Gratuit',
        pageDescription:
            'Découvrez le générateur vidéo IA Google Veo 3.1 avec image par image vers vidéo, matériel vers vidéo, génération audio native et plus. Essayez-le gratuitement sur la plateforme WeryAI pour créer des vidéos IA professionnelles.',
        pageKeywords:
            'Veo 3.1, générateur vidéo IA Google, création vidéo IA, vidéo intelligence artificielle, outil génération vidéo, vidéo IA gratuite, WeryAI, production vidéo',

        // Section du générateur
        generatorTitle: 'Générateur Vidéo IA Google Veo 3.1',
        generatorDescription:
            'WeryAI intègre désormais en profondeur le modèle Veo 3.1, C\'est une version améliorée de Veo 3 avec des améliorations significatives en qualité et fonctionnalités. Essayez Veo 3.1 gratuitement sur le générateur vidéo WeryAI !',

        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Veo 3.1',
        coreFeaturesSubtitle:
            'Explorez les capacités principales du générateur vidéo IA Google Veo 3.1 et découvrez la création vidéo IA de nouvelle génération',

        // Fonction image par image vers vidéo
        frameToVideoTitle:
            'Image par Image vers Vidéo (Contrôle de la Première et Dernière Image)',
        frameToVideoDescription:
            'Veo 3.1 prend en charge la génération vidéo via le contrôle de la première et dernière image, vous permettant de contrôler précisément les images de début et de fin de votre vidéo pour une narration visuelle plus cohérente.',
        frameToFrameTitle: 'Contrôle Image par Image',
        frameToFrameDescription:
            'Contrôlez la génération vidéo en spécifiant la première et la dernière image, créant des transitions fluides et des récits visuels cohérents.',

        // Fonction matériel vers vidéo
        materialToVideoTitle: 'Matériel vers Vidéo',
        materialToVideoDescription:
            'Créez des vidéos de haute qualité basées sur des matériaux et références existants, permettant une recréation intelligente et une amélioration visuelle de votre contenu.',

        // Fonction de génération audio native
        nativeAudioTitle: 'Génération Audio Native',
        nativeAudioDescription:
            "Veo 3.1 crée de l'audio et l'intègre dans les vidéos générées, réalisant une synchronisation audiovisuelle parfaite pour un contenu plus engageant et réaliste.",

        // Fonction personnage cohérent
        consistentCharacterTitle: 'Performance de Personnage Cohérente',
        consistentCharacterDescription:
            'Assure que les personnages maintiennent une apparence et des caractéristiques hautement cohérentes à travers différentes scènes et prises, créant une expérience visuelle cohérente.',

        // Fonction prompt avancé
        advancedPromptTitle: 'Compréhension Avancée des Prompts',
        advancedPromptDescription:
            'Interprète avec précision les prompts complexes, comprend exactement votre intention créative et transforme les descriptions textuelles en scènes visuelles vivantes.',

        // Fonction d'expansion de scène
        sceneExpansionTitle: 'Expansion de Scène Puissante',
        sceneExpansionDescription:
            "Étend intelligemment les scènes vidéo pour générer un contenu visuel plus riche, permettant à votre créativité de dépasser les limites de temps et d'espace.",

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Commencez à Créer en Trois Étapes Simples',
        step1Title: 'Sélectionner le Modèle',
        step1Description:
            'Choisissez le modèle Veo 3.1 dans les outils vidéo IA',
        step2Title: 'Saisir le Contenu',
        step2Description:
            'Entrez le prompt de texte ou téléchargez une image de référence',
        step3Title: 'Générer la Vidéo',
        step3Description:
            'Cliquez sur le bouton générer, attendez et téléchargez votre vidéo',

        // Section vidéos YouTube
        youtubeVideosTitle:
            'Vidéos YouTube sur le Modèle Vidéo IA Google Veo 3.1',
        youtubeVideoTitle:
            'Vidéos YouTube sur le Modèle Vidéo IA Google Veo 3.1',

        // Section publications X
        xPostsTitle: 'Publications X sur le Modèle Vidéo IA Veo 3.1',

        // Section explorer d'autres modèles
        exploreOtherModelsTitle: "Explorer d'Autres Modèles Veo",
        veo2Title: 'Générateur Vidéo IA Google Veo 2',
        veo3Title: 'Générateur Vidéo IA Google Veo 3',
        veo3FastTitle: 'Générateur Vidéo IA Google Veo 3 Fast',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaSubtitle:
            'Essayez Veo 3.1 maintenant et transformez vos idées en vidéos époustouflantes',
        ctaDescription:
            'Découvrez la puissance de Veo 3.1 et transformez vos idées créatives en contenu vidéo professionnel.',
        ctaButton: 'Essayez Veo 3.1 sur WeryAI',
        ctaNote: 'Aucune carte de crédit requise',

        // Lié à la lecture vidéo
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle:
            'Google Veo 3.1 KI-Video-Generator - Kostenfreies Fortgeschrittenes KI-Videoerstellungstool',
        pageDescription:
            'Erleben Sie den Google Veo 3.1 KI-Video-Generator mit Frame-zu-Video, Material-zu-Video, nativer Audiogenerierung und mehr. Testen Sie es kostenlos auf der WeryAI-Plattform, um professionelle KI-Videos zu erstellen.',
        pageKeywords:
            'Veo 3.1, Google KI-Video-Generator, KI-Videoerstellung, künstliche Intelligenz Video, Video-Generierungstool, kostenloses KI-Video, WeryAI, Videoproduktion',

        // Generator-Abschnitt
        generatorTitle: 'Google Veo 3.1 KI-Video-Generator',
        generatorDescription:
            'WeryAI integriert jetzt das Modell Veo 3.1 tiefgreifend, das hochwertige, realistische audiovisuelle Inhalte generiert. Es ist eine verbesserte Version von Veo 3 mit erheblichen Verbesserungen in Qualität und Funktionen. Testen Sie Veo 3.1 kostenlos auf dem WeryAI Video Generator!',

        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Kernfunktionen von Veo 3.1',
        coreFeaturesSubtitle:
            'Erkunden Sie die Kernfähigkeiten des Google Veo 3.1 KI-Videogenerators und erleben Sie die KI-Videoerstellung der nächsten Generation',

        // Frame-zu-Video-Funktion
        frameToVideoTitle:
            'Frame-zu-Video (Kontrolle von Erstem und Letztem Frame)',
        frameToVideoDescription:
            'Veo 3.1 unterstützt Videogenerierung durch Kontrolle von erstem und letztem Frame, sodass Sie die Start- und Endframes Ihres Videos präzise steuern können für kohärenteres visuelles Storytelling.',
        frameToFrameTitle: 'Frame-zu-Frame-Kontrolle',
        frameToFrameDescription:
            'Kontrollieren Sie die Videogenerierung durch Angabe des ersten und letzten Frames, um flüssige Übergänge und kohärente visuelle Erzählungen zu erstellen.',

        // Material-zu-Video-Funktion
        materialToVideoTitle: 'Material zu Video',
        materialToVideoDescription:
            'Erstellen Sie hochwertige Videos basierend auf vorhandenen Materialien und Referenzen, die intelligente Neugestaltung und visuelle Verbesserung Ihrer Inhalte ermöglichen.',

        // Native Audiogenerierungsfunktion
        nativeAudioTitle: 'Native Audiogenerierung',
        nativeAudioDescription:
            'Veo 3.1 erstellt Audio und integriert es in generierte Videos, erreicht perfekte audiovisuelle Synchronisation für ansprechendere und realistischere Inhalte.',

        // Konsistente Charakterfunktion
        consistentCharacterTitle: 'Konsistente Charakterperformance',
        consistentCharacterDescription:
            'Stellt sicher, dass Charaktere über verschiedene Szenen und Aufnahmen hinweg eine hochgradig konsistente Erscheinung und Merkmale beibehalten und ein kohärentes visuelles Erlebnis schaffen.',

        // Erweiterte Prompt-Funktion
        advancedPromptTitle: 'Erweitertes Prompt-Verständnis',
        advancedPromptDescription:
            'Interpretiert präzise komplexe Prompts, versteht genau Ihre kreative Absicht und verwandelt Textbeschreibungen in lebendige visuelle Szenen.',

        // Szenenerweiterungsfunktion
        sceneExpansionTitle: 'Leistungsstarke Szenenerweiterung',
        sceneExpansionDescription:
            'Erweitert intelligent Videoszenen, um reicheren visuellen Inhalt zu generieren, sodass Ihre Kreativität Zeit- und Raumbeschränkungen durchbrechen kann.',

        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle:
            'Beginnen Sie mit dem Erstellen in Drei Einfachen Schritten',
        step1Title: 'Modell Auswählen',
        step1Description:
            'Wählen Sie das Veo 3.1-Modell in den KI-Videowerkzeugen',
        step2Title: 'Inhalt Eingeben',
        step2Description:
            'Geben Sie Text-Prompt ein oder laden Sie Referenzbild hoch',
        step3Title: 'Video Generieren',
        step3Description:
            'Klicken Sie auf den Generieren-Button, warten Sie und laden Sie Ihr Video herunter',

        // YouTube-Videos-Abschnitt
        youtubeVideosTitle:
            'YouTube-Videos über das Google Veo 3.1 KI-Videomodell',
        youtubeVideoTitle:
            'YouTube-Videos über das Google Veo 3.1 KI-Videomodell',

        // X-Posts-Abschnitt
        xPostsTitle: 'X-Beiträge über das Veo 3.1 KI-Videomodell',

        // Andere Modelle erkunden-Abschnitt
        exploreOtherModelsTitle: 'Andere Veo-Modelle Erkunden',
        veo2Title: 'Google Veo 2 KI-Videogenerator',
        veo3Title: 'Google Veo 3 KI-Videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast KI-Videogenerator',

        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',

        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaSubtitle:
            'Testen Sie Veo 3.1 jetzt und verwandeln Sie Ihre Ideen in atemberaubende Videos',
        ctaDescription:
            'Erleben Sie die Leistungsfähigkeit von Veo 3.1 und verwandeln Sie Ihre kreativen Ideen in professionelle Videoinhalte.',
        ctaButton: 'Testen Sie Veo 3.1 auf WeryAI',
        ctaNote: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadError: 'Videoladen fehlgeschlagen',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle:
            'Генератор Видео ИИ Google Veo 3.1 - Бесплатный Продвинутый Инструмент Создания Видео ИИ',
        pageDescription:
            'Испытайте генератор видео ИИ Google Veo 3.1 с кадр в видео, материал в видео, генерацией нативного аудио и многим другим. Попробуйте бесплатно на платформе WeryAI для создания профессиональных ИИ-видео.',
        pageKeywords:
            'Veo 3.1, генератор видео ИИ Google, создание видео ИИ, видео искусственного интеллекта, инструмент генерации видео, бесплатное ИИ-видео, WeryAI, производство видео',

        // Раздел генератора
        generatorTitle: 'Генератор Видео ИИ Google Veo 3.1',
        generatorDescription:
            'WeryAI теперь глубоко интегрировал модель Veo 3.1, которая генерирует высококачественный, реалистичный аудиовизуальный контент. Это улучшенная версия Veo 3 со значительными улучшениями качества и функций. Попробуйте Veo 3.1 бесплатно на генераторе видео WeryAI!',

        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Veo 3.1',
        coreFeaturesSubtitle:
            'Изучите основные возможности генератора видео ИИ Google Veo 3.1 и познакомьтесь с созданием видео с ИИ следующего поколения',

        // Функция кадр в видео
        frameToVideoTitle: 'Кадр в Видео (Контроль Первого и Последнего Кадра)',
        frameToVideoDescription:
            'Veo 3.1 поддерживает генерацию видео через контроль первого и последнего кадра, позволяя вам точно контролировать начальный и конечный кадры вашего видео для более связного визуального повествования.',
        frameToFrameTitle: 'Покадровый Контроль',
        frameToFrameDescription:
            'Контролируйте генерацию видео, указывая первый и последний кадр, создавая плавные переходы и связные визуальные повествования.',

        // Функция материал в видео
        materialToVideoTitle: 'Материал в Видео',
        materialToVideoDescription:
            'Создавайте высококачественные видео на основе существующих материалов и ссылок, обеспечивая интеллектуальное воссоздание и визуальное улучшение вашего контента.',

        // Функция генерации нативного аудио
        nativeAudioTitle: 'Генерация Нативного Аудио',
        nativeAudioDescription:
            'Veo 3.1 создает аудио и интегрирует его в сгенерированные видео, достигая идеальной аудиовизуальной синхронизации для более привлекательного и реалистичного контента.',

        // Функция последовательного персонажа
        consistentCharacterTitle: 'Последовательное Исполнение Персонажей',
        consistentCharacterDescription:
            'Гарантирует, что персонажи сохраняют высокую последовательность внешнего вида и характеристик в разных сценах и кадрах, создавая связный визуальный опыт.',

        // Функция расширенного промпта
        advancedPromptTitle: 'Расширенное Понимание Промптов',
        advancedPromptDescription:
            'Точно интерпретирует сложные промпты, точно понимает ваше творческое намерение и преобразует текстовые описания в живые визуальные сцены.',

        // Функция расширения сцен
        sceneExpansionTitle: 'Мощное Расширение Сцен',
        sceneExpansionDescription:
            'Интеллектуально расширяет видеосцены для генерации более богатого визуального контента, позволяя вашей креативности преодолевать ограничения времени и пространства.',

        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Начните Создавать в Три Простых Шага',
        step1Title: 'Выберите Модель',
        step1Description: 'Выберите модель Veo 3.1 в инструментах видео с ИИ',
        step2Title: 'Введите Содержимое',
        step2Description:
            'Введите текстовый промпт или загрузите референсное изображение',
        step3Title: 'Сгенерируйте Видео',
        step3Description:
            'Нажмите кнопку генерации, дождитесь и скачайте ваше видео',

        // Раздел видео на YouTube
        youtubeVideosTitle: 'Видео на YouTube о модели видео ИИ Google Veo 3.1',
        youtubeVideoTitle: 'Видео на YouTube о модели видео ИИ Google Veo 3.1',

        // Раздел постов X
        xPostsTitle: 'Посты X о модели видео ИИ Veo 3.1',

        // Раздел исследования других моделей
        exploreOtherModelsTitle: 'Исследовать Другие Модели Veo',
        veo2Title: 'Генератор видео ИИ Google Veo 2',
        veo3Title: 'Генератор видео ИИ Google Veo 3',
        veo3FastTitle: 'Генератор видео ИИ Google Veo 3 Fast',

        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',

        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaSubtitle:
            'Попробуйте Veo 3.1 сейчас и превратите свои идеи в потрясающие видео',
        ctaDescription:
            'Испытайте мощь Veo 3.1 и превратите свои творческие идеи в профессиональный видеоконтент.',
        ctaButton: 'Попробуйте Veo 3.1 на WeryAI',
        ctaNote: 'Кредитная карта не требуется',

        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle:
            'Gerador de Vídeo IA Google Veo 3.1 - Ferramenta Avançada de Criação de Vídeo IA Grátis',
        pageDescription:
            'Experimente o gerador de vídeo IA Google Veo 3.1 com quadro a vídeo, material para vídeo, geração de áudio nativo e mais. Experimente grátis na plataforma WeryAI para criar vídeos IA profissionais.',
        pageKeywords:
            'Veo 3.1, gerador de vídeo IA Google, criação de vídeo IA, vídeo inteligência artificial, ferramenta geração vídeo, vídeo IA grátis, WeryAI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo IA Google Veo 3.1',
        generatorDescription:
            'O WeryAI agora integra profundamente o modelo Veo 3.1, É uma versão melhorada do Veo 3 com melhorias significativas em qualidade e recursos. Experimente Veo 3.1 gratuitamente no gerador de vídeo WeryAI!',

        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Veo 3.1',
        coreFeaturesSubtitle:
            'Explore as capacidades principais do gerador de vídeo IA Google Veo 3.1 e experimente a criação de vídeo IA de próxima geração',

        // Função quadro a vídeo
        frameToVideoTitle:
            'Quadro a Vídeo (Controle do Primeiro e Último Quadro)',
        frameToVideoDescription:
            'Veo 3.1 suporta geração de vídeo através do controle do primeiro e último quadro, permitindo que você controle com precisão os quadros inicial e final do seu vídeo para uma narrativa visual mais coerente.',
        frameToFrameTitle: 'Controle Quadro a Quadro',
        frameToFrameDescription:
            'Controle a geração de vídeo especificando o primeiro e último quadro, criando transições suaves e narrativas visuais coerentes.',

        // Função material para vídeo
        materialToVideoTitle: 'Material para Vídeo',
        materialToVideoDescription:
            'Crie vídeos de alta qualidade baseados em materiais e referências existentes, permitindo recriação inteligente e aprimoramento visual do seu conteúdo.',

        // Função de geração de áudio nativo
        nativeAudioTitle: 'Geração de Áudio Nativo',
        nativeAudioDescription:
            'Veo 3.1 cria áudio e o integra em vídeos gerados, alcançando sincronização audiovisual perfeita para conteúdo mais envolvente e realista.',

        // Função personagem consistente
        consistentCharacterTitle: 'Performance de Personagem Consistente',
        consistentCharacterDescription:
            'Garante que os personagens mantenham aparência e características altamente consistentes em diferentes cenas e tomadas, criando uma experiência visual coerente.',

        // Função prompt avançado
        advancedPromptTitle: 'Compreensão Avançada de Prompts',
        advancedPromptDescription:
            'Interpreta com precisão prompts complexos, compreende exatamente sua intenção criativa e transforma descrições de texto em cenas visuais vívidas.',

        // Função de expansão de cena
        sceneExpansionTitle: 'Expansão de Cena Poderosa',
        sceneExpansionDescription:
            'Expande inteligentemente as cenas de vídeo para gerar conteúdo visual mais rico, permitindo que sua criatividade rompa as limitações de tempo e espaço.',

        // Seção como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Comece a Criar em Três Passos Simples',
        step1Title: 'Selecionar Modelo',
        step1Description:
            'Escolha o modelo Veo 3.1 nas ferramentas de vídeo IA',
        step2Title: 'Inserir Conteúdo',
        step2Description:
            'Digite prompt de texto ou carregue imagem de referência',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique no botão gerar, aguarde e baixe seu vídeo',

        // Seção de vídeos do YouTube
        youtubeVideosTitle:
            'Vídeos do YouTube sobre o Modelo de Vídeo IA Google Veo 3.1',
        youtubeVideoTitle:
            'Vídeos do YouTube sobre o Modelo de Vídeo IA Google Veo 3.1',

        // Seção de publicações X
        xPostsTitle: 'Publicações X sobre o Modelo de Vídeo IA Veo 3.1',

        // Seção explorar outros modelos
        exploreOtherModelsTitle: 'Explorar Outros Modelos Veo',
        veo2Title: 'Gerador de Vídeo IA Google Veo 2',
        veo3Title: 'Gerador de Vídeo IA Google Veo 3',
        veo3FastTitle: 'Gerador de Vídeo IA Google Veo 3 Fast',

        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaSubtitle:
            'Experimente o Veo 3.1 agora e transforme suas ideias em vídeos impressionantes',
        ctaDescription:
            'Experimente o poder do Veo 3.1 e transforme suas ideias criativas em conteúdo de vídeo profissional.',
        ctaButton: 'Experimente o Veo 3.1 no WeryAI',
        ctaNote: 'Não é necessário cartão de crédito',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle:
            'Generatore Video IA Google Veo 3.1 - Strumento Avanzato di Creazione Video IA Gratis',
        pageDescription:
            'Sperimenta il generatore video IA Google Veo 3.1 con fotogramma a video, materiale a video, generazione audio nativa e altro. Provalo gratis sulla piattaforma WeryAI per creare video IA professionali.',
        pageKeywords:
            'Veo 3.1, generatore video IA Google, creazione video IA, video intelligenza artificiale, strumento generazione video, video IA gratuito, WeryAI, produzione video',

        // Sezione generatore
        generatorTitle: 'Generatore Video IA Google Veo 3.1',
        generatorDescription:
            'WeryAI integra ora in profondità il modello Veo 3.1, È una versione migliorata di Veo 3 con miglioramenti significativi in qualità e funzionalità. Prova Veo 3.1 gratuitamente sul generatore video WeryAI!',

        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Veo 3.1',
        coreFeaturesSubtitle:
            'Esplora le capacità principali del generatore video IA Google Veo 3.1 e sperimenta la creazione video IA di nuova generazione',

        // Funzione fotogramma a video
        frameToVideoTitle:
            'Fotogramma a Video (Controllo del Primo e Ultimo Fotogramma)',
        frameToVideoDescription:
            'Veo 3.1 supporta la generazione video tramite controllo del primo e ultimo fotogramma, permettendoti di controllare con precisione i fotogrammi iniziale e finale del tuo video per una narrazione visiva più coerente.',
        frameToFrameTitle: 'Controllo Fotogramma per Fotogramma',
        frameToFrameDescription:
            "Controlla la generazione video specificando il primo e l'ultimo fotogramma, creando transizioni fluide e narrazioni visive coerenti.",

        // Funzione materiale a video
        materialToVideoTitle: 'Materiale a Video',
        materialToVideoDescription:
            'Crea video di alta qualità basati su materiali e riferimenti esistenti, abilitando ricreazione intelligente e miglioramento visivo del tuo contenuto.',

        // Funzione generazione audio nativa
        nativeAudioTitle: 'Generazione Audio Nativa',
        nativeAudioDescription:
            'Veo 3.1 crea audio e lo integra nei video generati, ottenendo una sincronizzazione audiovisiva perfetta per contenuti più coinvolgenti e realistici.',

        // Funzione personaggio coerente
        consistentCharacterTitle: 'Performance del Personaggio Coerente',
        consistentCharacterDescription:
            "Assicura che i personaggi mantengano aspetto e caratteristiche altamente coerenti attraverso scene e inquadrature diverse, creando un'esperienza visiva coerente.",

        // Funzione prompt avanzato
        advancedPromptTitle: 'Comprensione Avanzata dei Prompt',
        advancedPromptDescription:
            'Interpreta con precisione prompt complessi, comprende esattamente la tua intenzione creativa e trasforma descrizioni testuali in scene visive vivide.',

        // Funzione espansione scena
        sceneExpansionTitle: 'Espansione Scena Potente',
        sceneExpansionDescription:
            'Espande intelligentemente le scene video per generare contenuti visivi più ricchi, permettendo alla tua creatività di superare i limiti di tempo e spazio.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Inizia a Creare in Tre Semplici Passaggi',
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello Veo 3.1 negli strumenti video IA',
        step2Title: 'Inserisci Contenuto',
        step2Description:
            'Inserisci prompt di testo o carica immagine di riferimento',
        step3Title: 'Genera Video',
        step3Description:
            'Clicca sul pulsante genera, attendi e scarica il tuo video',

        // Sezione video YouTube
        youtubeVideosTitle: 'Video YouTube sul Modello Video IA Google Veo 3.1',
        youtubeVideoTitle: 'Video YouTube sul Modello Video IA Google Veo 3.1',

        // Sezione post X
        xPostsTitle: 'Post X sul Modello Video IA Veo 3.1',

        // Sezione esplora altri modelli
        exploreOtherModelsTitle: 'Esplora Altri Modelli Veo',
        veo2Title: 'Generatore Video IA Google Veo 2',
        veo3Title: 'Generatore Video IA Google Veo 3',
        veo3FastTitle: 'Generatore Video IA Google Veo 3 Fast',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaSubtitle:
            'Prova Veo 3.1 ora e trasforma le tue idee in video straordinari',
        ctaDescription:
            'Sperimenta la potenza di Veo 3.1 e trasforma le tue idee creative in contenuti video professionali.',
        ctaButton: 'Prova Veo 3.1 su WeryAI',
        ctaNote: 'Non è richiesta la carta di credito',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle:
            'مولد فيديو الذكاء الاصطناعي Google Veo 3.1 - أداة إنشاء فيديو متقدمة بالذكاء الاصطناعي مجانية',
        pageDescription:
            'جرب مولد فيديو الذكاء الاصطناعي Google Veo 3.1 مع الإطار إلى فيديو والمواد إلى فيديو وتوليد الصوت الأصلي والمزيد. جربه مجانًا على منصة WeryAI لإنشاء مقاطع فيديو ذكاء اصطناعي احترافية.',
        pageKeywords:
            'Veo 3.1, مولد فيديو ذكاء اصطناعي من Google, إنشاء فيديو بالذكاء الاصطناعي, فيديو الذكاء الاصطناعي, أداة توليد الفيديو, فيديو ذكاء اصطناعي مجاني, WeryAI, إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        generatorDescription:
            'يقوم WeryAI الآن بدمج نموذج Veo 3.1 بعمق، إنها نسخة محسّنة من Veo 3 مع تحسينات كبيرة في الجودة والميزات. جرب Veo 3.1 مجانًا على مولد الفيديو WeryAI!',

        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Veo 3.1',
        coreFeaturesSubtitle:
            'استكشف القدرات الأساسية لمولد الفيديو بالذكاء الاصطناعي Google Veo 3.1 واختبر إنشاء فيديو بالذكاء الاصطناعي من الجيل التالي',

        // وظيفة إطار إلى فيديو
        frameToVideoTitle: 'إطار إلى فيديو (التحكم في الإطار الأول والأخير)',
        frameToVideoDescription:
            'يدعم Veo 3.1 توليد الفيديو من خلال التحكم في الإطار الأول والأخير، مما يتيح لك التحكم بدقة في إطارات البداية والنهاية لفيديوك للحصول على سرد بصري أكثر تماسكًا.',
        frameToFrameTitle: 'التحكم إطار بإطار',
        frameToFrameDescription:
            'تحكم في توليد الفيديو من خلال تحديد الإطار الأول والأخير، مما يخلق انتقالات سلسة وسرديات بصرية متماسكة.',

        // وظيفة مواد إلى فيديو
        materialToVideoTitle: 'مواد إلى فيديو',
        materialToVideoDescription:
            'أنشئ مقاطع فيديو عالية الجودة بناءً على المواد والمراجع الحالية، مما يمكّن من إعادة الإنشاء الذكي والتحسين البصري لمحتواك.',

        // وظيفة توليد الصوت الأصلي
        nativeAudioTitle: 'توليد الصوت الأصلي',
        nativeAudioDescription:
            'يُنشئ Veo 3.1 الصوت ويدمجه في مقاطع الفيديو المُنشأة، محققًا مزامنة سمعية بصرية مثالية لمحتوى أكثر جاذبية وواقعية.',

        // وظيفة شخصية متسقة
        consistentCharacterTitle: 'أداء شخصية متسق',
        consistentCharacterDescription:
            'يضمن أن الشخصيات تحافظ على مظهر وخصائص متسقة للغاية عبر مشاهد ولقطات مختلفة، مما يخلق تجربة بصرية متماسكة.',

        // وظيفة مطالبة متقدمة
        advancedPromptTitle: 'فهم متقدم للمطالبات',
        advancedPromptDescription:
            'يفسر بدقة المطالبات المعقدة، ويفهم بالضبط نيتك الإبداعية ويحول الأوصاف النصية إلى مشاهد بصرية حية.',

        // وظيفة توسيع المشهد
        sceneExpansionTitle: 'توسيع مشهد قوي',
        sceneExpansionDescription:
            'يوسع بذكاء مشاهد الفيديو لتوليد محتوى بصري أكثر ثراءً، مما يسمح لإبداعك بكسر قيود الزمان والمكان.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ابدأ الإنشاء في ثلاث خطوات بسيطة',
        step1Title: 'اختر النموذج',
        step1Description:
            'اختر نموذج Veo 3.1 في أدوات الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل مطالبة نصية أو قم بتحميل صورة مرجعية',
        step3Title: 'أنشئ الفيديو',
        step3Description:
            'انقر فوق زر الإنشاء، انتظر وقم بتنزيل الفيديو الخاص بك',

        // قسم فيديوهات YouTube
        youtubeVideosTitle:
            'فيديوهات YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        youtubeVideoTitle:
            'فيديوهات YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3.1',

        // قسم منشورات X
        xPostsTitle: 'منشورات X حول نموذج الفيديو بالذكاء الاصطناعي Veo 3.1',

        // قسم استكشاف نماذج أخرى
        exploreOtherModelsTitle: 'استكشف نماذج Veo الأخرى',
        veo2Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 2',
        veo3Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3',
        veo3FastTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3 Fast',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaSubtitle: 'جرب Veo 3.1 الآن وحوّل أفكارك إلى مقاطع فيديو مذهلة',
        ctaDescription:
            'اختبر قوة Veo 3.1 وحوّل أفكارك الإبداعية إلى محتوى فيديو احترافي.',
        ctaButton: 'جرب Veo 3.1 على WeryAI',
        ctaNote: 'لا حاجة لبطاقة ائتمان',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | โมเดลสร้างวิดีโอ AI ขั้นสูง | WeryAI',
        pageDescription:
            'Google Veo 3.1 สร้างวิดีโอคุณภาพสูงสมจริงด้วยการควบคุมเฟรม วัสดุเป็นวิดีโอ เสียงเนทีฟ การขยายฉาก และความเข้าใจพรอมต์อย่างแม่นยำ ทดลองฟรีบน WeryAI',
        pageKeywords:
            'Veo 3.1, Google Veo, เครื่องมือสร้างวิดีโอ AI, โมเดลวิดีโอขั้นสูง, ข้อความเป็นวิดีโอ, การสร้างวิดีโอ AI, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        generatorDescription:
            'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3.1 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3.1 อย่างลึกซึ้งแล้ว 1 ฟรีบนเครื่องมือสร้างวิดีโอ WeryAI!',

        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Veo 3.1',
        coreFeaturesSubtitle:
            'สำรวจความสามารถหลักของเครื่องมือสร้างวิดีโอ AI Google Veo 3.1 และสัมผัสการสร้างวิดีโอ AI เจเนอเรชันถัดไป',

        // Frame to video feature
        frameToVideoTitle: 'เฟรมเป็นวิดีโอ (ควบคุมเฟรมแรกและเฟรมสุดท้าย)',
        frameToVideoDescription:
            'Veo 3.1 รองรับการสร้างวิดีโอด้วยการควบคุมเฟรมแรกและเฟรมสุดท้าย ทำให้คุณกำหนดจุดเริ่มและจบของวิดีโอได้อย่างแม่นยำเพื่อการเล่าเรื่องที่ต่อเนื่อง',
        frameToFrameTitle: 'ควบคุมเฟรม-ต่อ-เฟรม',
        frameToFrameDescription:
            'ควบคุมการสร้างวิดีโอด้วยการระบุเฟรมแรกและเฟรมสุดท้าย เพื่อการเปลี่ยนฉากที่ลื่นไหลและการเล่าเรื่องที่สอดคล้อง',

        // Material to video feature
        materialToVideoTitle: 'วัสดุเป็นวิดีโอ',
        materialToVideoDescription:
            'สร้างวิดีโอคุณภาพสูงจากวัสดุและอ้างอิงที่มีอยู่ ช่วยให้การสร้างซ้ำอย่างชาญฉลาดและเพิ่มคุณภาพภาพให้คอนเทนต์ของคุณ',

        // Native audio generation feature
        nativeAudioTitle: 'การสร้างเสียงเนทีฟ',
        nativeAudioDescription:
            'Veo 3.1 สร้างเสียงและผสานเข้ากับวิดีโอที่สร้างขึ้น เพื่อซิงก์เสียง-ภาพอย่างสมบูรณ์ ทำให้คอนเทนต์น่าดึงดูดและสมจริงขึ้น',

        // Consistent character feature
        consistentCharacterTitle: 'การแสดงตัวละครที่สม่ำเสมอ',
        consistentCharacterDescription:
            'ทำให้ตัวละครมีรูปลักษณ์และคุณลักษณะสอดคล้องกันในทุกฉากและช็อต สร้างประสบการณ์ภาพที่ต่อเนื่อง',

        // Advanced prompt feature
        advancedPromptTitle: 'ความเข้าใจพรอมต์ขั้นสูง',
        advancedPromptDescription:
            'ตีความพรอมต์ซับซ้อนได้อย่างแม่นยำ เข้าใจเจตนาสร้างสรรค์ และแปลงคำอธิบายเป็นฉากภาพที่มีชีวิตชีวา',

        // Scene expansion feature
        sceneExpansionTitle: 'การขยายฉากที่ทรงพลัง',
        sceneExpansionDescription:
            'ขยายฉากวิดีโออย่างชาญฉลาดเพื่อสร้างคอนเทนต์ภาพที่สมบูรณ์ยิ่งขึ้น ทำให้ความคิดสร้างสรรค์ก้าวข้ามข้อจำกัดด้านเวลาและพื้นที่',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'เริ่มสร้างได้ใน 3 ขั้นตอนง่าย ๆ',
        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Veo 3.1 ในเครื่องมือวิดีโอ AI',
        step2Title: 'ป้อนเนื้อหา',
        step2Description: 'พิมพ์พรอมต์ข้อความหรืออัปโหลดภาพอ้างอิง',
        step3Title: 'สร้างวิดีโอ',
        step3Description: 'คลิกปุ่มสร้าง รอ แล้วดาวน์โหลดวิดีโอของคุณ',

        // YouTube videos section
        youtubeVideosTitle:
            'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3.1',
        youtubeVideoTitle:
            'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3.1',

        // X Posts section
        xPostsTitle: 'โพสต์บน X เกี่ยวกับโมเดลวิดีโอ AI Veo 3.1',

        // Explore other models section
        exploreOtherModelsTitle: 'สำรวจโมเดล Veo อื่น ๆ',
        veo2Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 2',
        veo3Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3',
        veo3FastTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA section
        ctaTitle: 'เตรียมพร้อมเริ่มสร้างสรรค์แล้วหรือยัง？',
        ctaSubtitle:
            'ลอง Veo 3.1 ตอนนี้และเปลี่ยนไอเดียเป็นวิดีโอสุดตระการตา',
        ctaDescription:
            'สัมผัสพลังของ Veo 3.1 และเปลี่ยนไอเดียสร้างสรรค์ให้เป็นคอนเทนต์วิดีโอระดับมืออาชีพ',
        ctaButton: 'เริ่มสร้างสรรค์',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต · ทดลองใช้ฟรีสำหรับผู้ใช้ใหม่',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Avanceret AI-videomodel | WeryAI',
        pageDescription:
            'Google Veo 3.1 skaber realistiske videoer i høj kvalitet med frame-kontrol, material-to-video, indbygget lyd, sceneudvidelse og præcis promptforståelse. Prøv gratis på WeryAI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, avanceret videomodel, tekst til video, AI-videoskabelse, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'WeryAI har nu integreret modellen Veo 3.1 i dybden, som genererer realistisk audio-video i høj kvalitet. Den er en opgraderet version af Veo 3 med markante forbedringer i kvalitet og funktioner. Prøv Veo 3.1 gratis på WeryAI-videogeneratoren!',

        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kernefunktioner',
        coreFeaturesSubtitle:
            'Udforsk kernefunktionerne i Google Veo 3.1 AI-videogenerator og oplev næste generations AI-videoskabelse',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (første og sidste frame-kontrol)',
        frameToVideoDescription:
            'Veo 3.1 understøtter videogenerering med kontrol af første og sidste frame, så du kan styre start og slut præcist for mere sammenhængende visuel storytelling.',
        frameToFrameTitle: 'Frame-to-Frame-kontrol',
        frameToFrameDescription:
            'Styr videogenereringen ved at angive første og sidste frame, så du får glatte overgange og sammenhængende visuelle fortællinger.',

        // Material to video feature
        materialToVideoTitle: 'Materiale til video',
        materialToVideoDescription:
            'Skab videoer i høj kvalitet baseret på eksisterende materiale og referencer, så du kan genskabe og forbedre indhold visuelt.',

        // Native audio generation feature
        nativeAudioTitle: 'Indbygget lydgenerering',
        nativeAudioDescription:
            'Veo 3.1 skaber lyd og integrerer den i videoerne for perfekt lyd-billedsynk, som gør indholdet mere engagerende og realistisk.',

        // Consistent character feature
        consistentCharacterTitle: 'Konsistent karakterpræstation',
        consistentCharacterDescription:
            'Sørg for at karakterer bevarer et meget ensartet udseende og egenskaber på tværs af scener og shots for en sammenhængende visuel oplevelse.',

        // Advanced prompt feature
        advancedPromptTitle: 'Avanceret promptforståelse',
        advancedPromptDescription:
            'Fortolk komplekse prompts præcist, forstå den kreative intention og omdan tekst til levende visuelle scener.',

        // Scene expansion feature
        sceneExpansionTitle: 'Kraftfuld sceneudvidelse',
        sceneExpansionDescription:
            'Udvid videoscener intelligent for at skabe rigere visuelt indhold og lade kreativiteten bryde tid- og rumbegrænsninger.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        howToUseSubtitle: 'Kom i gang med tre enkle trin',
        step1Title: 'Vælg model',
        step1Description: 'Vælg Veo 3.1-modellen i AI-videoværktøjer',
        step2Title: 'Indtast indhold',
        step2Description: 'Indtast tekstprompt eller upload referencebillede',
        step3Title: 'Generér video',
        step3Description: 'Klik på generér, vent og download din video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-videoer om Google Veo 3.1 AI-videomodel',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3.1 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-opslag om Veo 3.1 AI-videomodel',

        // Explore other models section
        exploreOtherModelsTitle: 'Udforsk andre Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaSubtitle:
            'Prøv Veo 3.1 nu og forvandl dine ideer til fantastiske videoer',
        ctaDescription:
            'Oplev kraften i Veo 3.1 og gør dine kreative ideer til professionelt videoindhold.',
        ctaButton: 'Begynd at skabe',
        ctaNote: 'Intet kreditkort påkrævet · Gratis prøveperiode for nye brugere',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadError: 'Video kunne ikke indlæses',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Avansert AI-videomodell | WeryAI',
        pageDescription:
            'Google Veo 3.1 lager realistiske videoer i høy kvalitet med frame-kontroll, material-to-video, innebygd lyd, sceneutvidelse og presis promptforståelse. Prøv gratis på WeryAI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, avansert videomodell, tekst til video, AI-videoskaping, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'WeryAI har nå integrert modellen Veo 3.1 i dybden, Den er en oppgradert versjon av Veo 3 med betydelige forbedringer i kvalitet og funksjoner. Prøv Veo 3.1 gratis på WeryAI-videogeneratoren!',

        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kjernefunksjoner',
        coreFeaturesSubtitle:
            'Utforsk kjernefunksjonene i Google Veo 3.1 AI-videogenerator og opplev neste generasjons AI-videoskaping',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (kontroll av første og siste frame)',
        frameToVideoDescription:
            'Veo 3.1 støtter videogenerering med kontroll av første og siste frame, slik at du kan styre start og slutt presist for mer sammenhengende visuell historiefortelling.',
        frameToFrameTitle: 'Frame-to-Frame-kontroll',
        frameToFrameDescription:
            'Styr videogenereringen ved å angi første og siste frame, for jevne overganger og sammenhengende visuelle narrativer.',

        // Material to video feature
        materialToVideoTitle: 'Materiale til video',
        materialToVideoDescription:
            'Lag videoer i høy kvalitet basert på eksisterende materiale og referanser, og forbedre innholdet visuelt på en intelligent måte.',

        // Native audio generation feature
        nativeAudioTitle: 'Innebygd lydgenerering',
        nativeAudioDescription:
            'Veo 3.1 lager lyd og integrerer den i videoene for perfekt lyd-bildesynk og mer engasjerende, realistisk innhold.',

        // Consistent character feature
        consistentCharacterTitle: 'Konsistent karakterprestasjon',
        consistentCharacterDescription:
            'Sørg for at karakterer holder et svært konsistent utseende og egenskaper på tvers av scener og shots, for en helhetlig visuell opplevelse.',

        // Advanced prompt feature
        advancedPromptTitle: 'Avansert promptforståelse',
        advancedPromptDescription:
            'Tolk komplekse prompts presist, forstå kreative intensjoner nøyaktig og gjør tekst til levende visuelle scener.',

        // Scene expansion feature
        sceneExpansionTitle: 'Kraftig sceneutvidelse',
        sceneExpansionDescription:
            'Utvid videoscener intelligent for å skape rikere visuelt innhold og la kreativiteten bryte tid- og rombegrensninger.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Kom i gang med tre enkle trinn',
        step1Title: 'Velg modell',
        step1Description: 'Velg Veo 3.1-modellen i AI-videoverktøy',
        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn tekstprompt eller last opp referansebilde',
        step3Title: 'Generer video',
        step3Description: 'Klikk generer, vent og last ned videoen din',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-videoer om Google Veo 3.1 AI-videomodell',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3.1 AI-videomodell',

        // X Posts section
        xPostsTitle: 'X-innlegg om Veo 3.1 AI-videomodell',

        // Explore other models section
        exploreOtherModelsTitle: 'Utforsk andre Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaSubtitle:
            'Prøv Veo 3.1 nå og gjør ideene dine om til imponerende videoer',
        ctaDescription:
            'Opplev kraften i Veo 3.1 og gjør kreative ideer om til profesjonelt videoinnhold.',
        ctaButton: 'Begynn å skape',
        ctaNote: 'Ingen kredittkort nødvendig · Gratis prøveperiode for nye brukere',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadError: 'Videoen kunne ikke lastes',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Geavanceerd AI-videomodel | WeryAI',
        pageDescription:
            'Google Veo 3.1 genereert realistische video’s van hoge kwaliteit met framecontrol, material-to-video, native audio, scène-uitbreiding en precieze promptbegrip. Probeer gratis op WeryAI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, geavanceerd videomodel, tekst naar video, AI-videocreatie, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'WeryAI heeft het model Veo 3.1 nu diep geïntegreerd, Het is een geüpgradede versie van Veo 3 met grote verbeteringen in kwaliteit en functies. Probeer Veo 3.1 gratis op de WeryAI-videogenerator!',

        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kernfuncties',
        coreFeaturesSubtitle:
            'Ontdek de kerncapaciteiten van de Google Veo 3.1 AI-videogenerator en ervaar next-gen AI-videocreatie',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (eerste en laatste frame control)',
        frameToVideoDescription:
            'Veo 3.1 ondersteunt videogeneratie met eerste en laatste frame control, zodat je de start- en eindframes precies kunt sturen voor samenhangende visual storytelling.',
        frameToFrameTitle: 'Frame-to-Frame control',
        frameToFrameDescription:
            'Stuur videogeneratie door het eerste en laatste frame op te geven, voor vloeiende overgangen en samenhangende visuele verhalen.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Maak video’s van hoge kwaliteit op basis van bestaande materialen en referenties, voor intelligente recreatie en visuele verbetering van je content.',

        // Native audio generation feature
        nativeAudioTitle: 'Native audiogeneratie',
        nativeAudioDescription:
            'Veo 3.1 maakt audio en integreert dit in de video’s voor perfecte audio-visuele synchronisatie en meer realistische content.',

        // Consistent character feature
        consistentCharacterTitle: 'Consistente karakterperformance',
        consistentCharacterDescription:
            'Zorg dat personages hun uiterlijk en kenmerken consistent houden over verschillende scènes en shots, voor een coherente visuele ervaring.',

        // Advanced prompt feature
        advancedPromptTitle: 'Geavanceerd promptbegrip',
        advancedPromptDescription:
            'Interpreteert complexe prompts nauwkeurig, begrijpt je creatieve intentie en zet tekst om in levendige visuele scènes.',

        // Scene expansion feature
        sceneExpansionTitle: 'Krachtige scène-uitbreiding',
        sceneExpansionDescription:
            'Breid videoscènes intelligent uit om rijkere visuals te maken en je creativiteit door tijd- en ruimtebeperkingen te laten breken.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Start met drie eenvoudige stappen',
        step1Title: 'Selecteer model',
        step1Description: 'Kies het Veo 3.1-model in de AI-videotools',
        step2Title: 'Voer content in',
        step2Description: 'Voer een tekstprompt in of upload een referentie-afbeelding',
        step3Title: 'Genereer video',
        step3Description: 'Klik op genereren, wacht en download je video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-video\'s over het Google Veo 3.1 AI-videomodel',
        youtubeVideoTitle:
            'YouTube-video\'s over het Google Veo 3.1 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-berichten over het Veo 3.1 AI-videomodel',

        // Explore other models section
        exploreOtherModelsTitle: 'Ontdek andere Veo-modellen',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',

        // CTA section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaSubtitle:
            'Probeer Veo 3.1 nu en zet je ideeën om in prachtige video’s',
        ctaDescription:
            'Ervaar de kracht van Veo 3.1 en maak van je creatieve ideeën professioneel videocontent.',
        ctaButton: 'Begin met creëren',
        ctaNote: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoUnsupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Model Generasi Video AI Lanjutan | WeryAI',
        pageDescription:
            'Google Veo 3.1 menghasilkan video realistis berkualitas tinggi dengan kontrol frame, material-to-video, audio native, ekspansi scene, dan pemahaman prompt yang presisi. Coba gratis di WeryAI.',
        pageKeywords:
            'Veo 3.1, Google Veo, generator video AI, model video lanjutan, teks ke video, pembuatan video AI, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Generator Video AI Google Veo 3.1',
        generatorDescription:
            'WeryAI kini telah mengintegrasikan model Veo 3.1 secara mendalam, Ini adalah versi upgrade dari Veo 3 dengan peningkatan besar pada kualitas dan fitur. Coba Veo 3.1 gratis di generator video WeryAI!',

        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Inti Veo 3.1',
        coreFeaturesSubtitle:
            'Jelajahi kemampuan inti generator video AI Google Veo 3.1 dan rasakan pembuatan video AI generasi berikutnya',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (Kontrol Frame Pertama & Terakhir)',
        frameToVideoDescription:
            'Veo 3.1 mendukung generasi video melalui kontrol frame pertama dan terakhir, sehingga Anda dapat mengatur awal dan akhir video secara presisi untuk storytelling yang lebih koheren.',
        frameToFrameTitle: 'Kontrol Frame-to-Frame',
        frameToFrameDescription:
            'Kontrol generasi video dengan menentukan frame pertama dan terakhir untuk transisi halus dan narasi visual yang konsisten.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Buat video berkualitas tinggi berdasarkan materi dan referensi yang ada, memungkinkan rekreasi cerdas dan peningkatan visual konten Anda.',

        // Native audio generation feature
        nativeAudioTitle: 'Generasi Audio Native',
        nativeAudioDescription:
            'Veo 3.1 menghasilkan audio dan mengintegrasikannya ke video sehingga sinkronisasi audio-visual sempurna untuk konten yang lebih menarik dan realistis.',

        // Consistent character feature
        consistentCharacterTitle: 'Performa Karakter yang Konsisten',
        consistentCharacterDescription:
            'Pastikan karakter tetap konsisten dalam penampilan dan karakteristik di berbagai scene dan shot untuk pengalaman visual yang koheren.',

        // Advanced prompt feature
        advancedPromptTitle: 'Pemahaman Prompt Lanjutan',
        advancedPromptDescription:
            'Menafsirkan prompt kompleks dengan presisi, memahami niat kreatif Anda secara akurat, dan mengubah deskripsi teks menjadi scene visual yang hidup.',

        // Scene expansion feature
        sceneExpansionTitle: 'Ekspansi Scene yang Kuat',
        sceneExpansionDescription:
            'Perluas scene video secara cerdas untuk menghasilkan konten visual yang lebih kaya, sehingga kreativitas Anda melampaui batas waktu dan ruang.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Mulai berkarya dalam tiga langkah sederhana',
        step1Title: 'Pilih Model',
        step1Description: 'Pilih model Veo 3.1 di alat video AI',
        step2Title: 'Masukkan Konten',
        step2Description: 'Masukkan prompt teks atau unggah gambar referensi',
        step3Title: 'Buat Video',
        step3Description: 'Klik tombol generate, tunggu, lalu unduh video Anda',

        // YouTube videos section
        youtubeVideosTitle:
            'Video YouTube tentang Model Video AI Google Veo 3.1',
        youtubeVideoTitle: 'Video YouTube tentang Model Video AI Google Veo 3.1',

        // X Posts section
        xPostsTitle: 'Posting X tentang Model Video AI Veo 3.1',

        // Explore other models section
        exploreOtherModelsTitle: 'Jelajahi Model Veo Lain',
        veo2Title: 'Generator Video AI Google Veo 2',
        veo3Title: 'Generator Video AI Google Veo 3',
        veo3FastTitle: 'Generator Video AI Google Veo 3 Fast',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA section
        ctaTitle: 'Siap untuk mulai berkarya?',
        ctaSubtitle:
            'Coba Veo 3.1 sekarang dan ubah ide Anda menjadi video yang menakjubkan',
        ctaDescription:
            'Rasakan kekuatan Veo 3.1 dan ubah ide kreatif Anda menjadi konten video profesional.',
        ctaButton: 'Mulai Berkarya',
        ctaNote: 'Tidak perlu kartu kredit · Uji coba gratis untuk pengguna baru',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Gelişmiş AI Video Üretim Modeli | WeryAI',
        pageDescription:
            'Google Veo 3.1, kare kontrolü, material-to-video, yerleşik ses, sahne genişletme ve hassas prompt anlayışıyla yüksek kaliteli, gerçekçi videolar üretir. WeryAI’de ücretsiz deneyin.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI video üretici, gelişmiş video modeli, metinden videoya, AI video oluşturma, WeryAI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI Video Üretici',
        generatorDescription:
            'WeryAI artık Veo 3.1 modelini derinlemesine entegre ediyor, yüksek kaliteli ve gerçekçi sesli-görsel içerik üreten en gelişmiş AI video modelidir. Veo 3’ün geliştirilmiş sürümüdür ve kalite ile özelliklerde önemli iyileştirmeler sunar. Veo 3.1’i WeryAI video üreticide ücretsiz deneyin!',

        // Tabs
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 Temel Özellikler',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI video üreticisinin temel yeteneklerini keşfedin ve yeni nesil AI video üretimini deneyimleyin',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (İlk ve Son Kare Kontrolü)',
        frameToVideoDescription:
            'Veo 3.1, ilk ve son kare kontrolüyle video üretimini destekler; böylece videonun başlangıç ve bitiş karelerini hassas biçimde kontrol ederek daha tutarlı bir görsel anlatı elde edersiniz.',
        frameToFrameTitle: 'Frame-to-Frame Kontrolü',
        frameToFrameDescription:
            'İlk ve son kareyi belirleyerek video üretimini kontrol edin; akıcı geçişler ve tutarlı görsel anlatılar oluşturun.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Mevcut materyal ve referanslara dayalı yüksek kaliteli videolar oluşturun; içeriklerinizi akıllıca yeniden üretip görsel olarak güçlendirin.',

        // Native audio generation feature
        nativeAudioTitle: 'Yerleşik Ses Üretimi',
        nativeAudioDescription:
            'Veo 3.1 sesi üretir ve videolara entegre eder; böylece mükemmel ses-görüntü senkronu ile daha gerçekçi ve etkileyici içerikler sağlar.',

        // Consistent character feature
        consistentCharacterTitle: 'Tutarlı Karakter Performansı',
        consistentCharacterDescription:
            'Karakterlerin farklı sahne ve çekimlerde görünüm ve özelliklerini yüksek tutarlılıkla korumasını sağlayarak bütünlüklü bir görsel deneyim oluşturun.',

        // Advanced prompt feature
        advancedPromptTitle: 'Gelişmiş Prompt Anlayışı',
        advancedPromptDescription:
            'Karmaşık promptları hassas biçimde yorumlar, yaratıcı niyetinizi doğru anlar ve metin açıklamalarını canlı görsel sahnelere dönüştürür.',

        // Scene expansion feature
        sceneExpansionTitle: 'Güçlü Sahne Genişletme',
        sceneExpansionDescription:
            'Videolu sahneleri akıllıca genişleterek daha zengin görsel içerikler üretin ve yaratıcılığınızın zaman-mekan sınırlarını aşmasını sağlayın.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Üç basit adımda başlayın',
        step1Title: 'Model Seçin',
        step1Description: 'AI video araçlarında Veo 3.1 modelini seçin',
        step2Title: 'İçerik Girin',
        step2Description: 'Metin promptu girin veya referans görsel yükleyin',
        step3Title: 'Video Üretin',
        step3Description: 'Oluştur düğmesine tıklayın, bekleyin ve videonuzu indirin',

        // YouTube videos section
        youtubeVideosTitle:
            'Google Veo 3.1 AI Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle:
            'Google Veo 3.1 AI Video Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Veo 3.1 AI Video Modeli Hakkında X Paylaşımları',

        // Explore other models section
        exploreOtherModelsTitle: 'Diğer Veo Modellerini Keşfedin',
        veo2Title: 'Google Veo 2 AI Video Üretici',
        veo3Title: 'Google Veo 3 AI Video Üretici',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça Sorulan Sorular',

        // CTA section
        ctaTitle: 'Hazır mısınız?',
        ctaSubtitle:
            'Veo 3.1’i şimdi deneyin ve fikirlerinizi etkileyici videolara dönüştürün',
        ctaDescription:
            'Veo 3.1’in gücünü deneyin ve yaratıcı fikirlerinizi profesyonel video içeriğine dönüştürün.',
        ctaButton: 'Oluşturmaya Başla',
        ctaNote: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
    },
}
